import {fabric} from "fabric-with-gestures";
import Circle from "../Cirle";
import Square from "../Square";

export default {
  methods:{
    findExistingTable(id){
      let a;
      this.tablesExisting.forEach((table) => {
        if (table.id == id) {
          a = table;
          return;
        }
      })
      return a;
    },
    loadTable(object){
      let existingTable = this.findExistingTable(object.my.id)

      if(existingTable){
        if(object.my.type == "Circle"){
            this.configurationCircle(object, existingTable)
        }
        if(object.my.type == "Square"){
          this.configurationSquare(object, existingTable)
        }
      }
    },
    configurationSquare(o, existingTable){
      let y = new Square();
      let widthAndHeight = this.getMaxWidthAndHeight(o.objects)
      y.angle = o.angle;
      y.countPerson = existingTable.countPerson;
      y.groupName = existingTable.number;
      y.groupId = existingTable.id;
      y.position.top = o.top;
      y.position.left = o.left;
      y.zoneId = existingTable.zoneId;
      y.width = widthAndHeight[0];
      y.height = widthAndHeight[1];
      this.tables.push(y);
    },
    configurationCircle(o, existingTable) {
      let y = new Circle();
      let radius = this.getMaxRadiusFromGroup(o.objects)
      y.angle = o.angle;
      y.countPerson = existingTable.countPerson;
      y.groupName = existingTable.number;
      y.groupId = existingTable.id;
      y.zoneId = existingTable.zoneId;
      y.position.top = o.top;
      y.position.left = o.left;
      y.radius = radius;
      this.tables.push(y);
    },
    getMaxWidthAndHeight(objects){
      let maxWidth = 0, maxHeight = 0;
      objects.forEach((object) => {
        if (object.width > maxWidth) {
          maxWidth = object.width;
        }
        if (object.height > maxHeight) {
          maxHeight = object.height;
        }
      })
      return [maxWidth, maxHeight];
    },
    getMaxRadiusFromGroup(objects){
      let maxRadius = 0;
      objects.forEach((object) => {
        if (object.radius > maxRadius) {
          maxRadius = object.radius;
          return;
        }
      })
      return maxRadius;
    },
  }
}
